export const maxTooltipSteps = 2;

export const FTUE_PORTFOLIOS_TOOLTIP_UI_FLAG =
  'HIDE_FTUE_PORTFOLIOS_TOOLTIP_GUIDE';
export const FTUE_PORTFOLIOS_TOOLTIP_PARAMETER = 'portfolioGuide';
